// eslint-disable-next-line no-unused-vars
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Metrics from 'services/metrics';
import { getRegion } from 'utils/Region';
import { withRouterListener } from 'utils/hocs/withRouterListener';
import Metadata from 'utils/apa/metadata';
import _ from 'lodash';
import Utils, { windowUtilsGetMetaMetadata as getMeta } from 'utils/Utils';

const TRANSACTIONAL_KEY = 'transactional_configuration';
const LOGGED_USER_KEY = 'loginInfo.logged_user';
const USER_DATA_KEY = 'loginInfo.logged_user_data';
const FOX_PLUS_KEY = 'Telmexmexico_abono_FOX_PLUS';
const YOUBORA_METADATA_KEY = 'youbora_options';

const REGION = getRegion();

const getUserType = (userData, foxplus) => {
  const is360 = Boolean(userData?.data360);
  const subscriptions = userData?.subscriptions;
  const transactionalConf = getMeta(TRANSACTIONAL_KEY)?.[REGION];
  const { products } = transactionalConf?.suscription || {};

  const user360 = is360 ? 'Registrado 360' : 'Registrado';
  const userAmco = subscriptions?.AMCO ? 'Suscrito' : 'Registrado';
  const userAmco360 = `${userAmco} 360`;

  if (!subscriptions) return user360;
  if (is360) return userAmco360;

  const subs = Object.keys(subscriptions)
    .map(e => _.findKey(products, o => o.includes(e)))
    .filter(e => e && e !== 'amco');

  return [userAmco, ...subs, foxplus].filter(x => x.length > 0).join('+');
};

const routeEvent = () => {
  const userType = 'Anonimo';
  const country = Utils.getAbbreviation(REGION);
  const pageType = `${window.location.pathname}${window.location.search}`;

  const isLogged = localStorage.getItem(LOGGED_USER_KEY);
  const userData = JSON.parse(localStorage.getItem(USER_DATA_KEY));

  const event = {
    id: '',
    userType,
    country,
    pageType,
  };

  if (!userData || isLogged !== 'true') return event;

  const subscriptions = Array.isArray(userData.profile?.subscriptions) ? userData.profile.subscriptions : [];
  const isFoxPlus = subscriptions.find(foxplus => foxplus.key === FOX_PLUS_KEY) || false;

  const foxplus = isFoxPlus ? 'Foxplus' : '';

  event.id = userData.user_id;
  event.userType = getUserType(userData, foxplus);

  return event;
};

const MetricsProvider = ({ children, history }) => {
  const [ready, setReady] = useState(false);
  const metadata = useSelector(state => state.metadata);
  const userId = useSelector(state => state.user.user_id);

  const { findMetadataByKey } = new Metadata(metadata, getRegion());
  const { analytics } = findMetadataByKey(YOUBORA_METADATA_KEY);

  useEffect(() => {
    if (analytics?.enabled) {
      Metrics.start({
        accountCode: analytics?.accountcode,
        service: analytics?.host,
        username: userId,
      });

      history.listen(() => {
        Metrics.navigationEvent(routeEvent());
      });

      window.addEventListener('beforeunload', Metrics.stop);
    }
  }, []);

  useEffect(
    () => {
      if (analytics?.enabled) {
        Metrics.newSession({
          accountCode: analytics?.accountcode,
          service: analytics?.host,
          username: userId,
        });
      }

      setReady(true);
    },
    [userId],
  );

  if (!ready) return null;

  return <>{children}</>;
};

export default withRouterListener(MetricsProvider);
